import React from "react";
import {
  GoogleLogin as OAuthGoogleLogin,
  GoogleOAuthProvider,
} from "@react-oauth/google";

const decodeJwtPayload = (token) => {
  const [, payload = ""] = token.split(".");
  const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
  const decoded = window.atob(padded);
  const json = decodeURIComponent(
    Array.from(decoded)
      .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`)
      .join("")
  );

  return JSON.parse(json);
};

const getGoogleButtonText = (buttonText = "") => {
  if (/sign up/i.test(buttonText)) {
    return "signup_with";
  }

  if (/continue/i.test(buttonText)) {
    return "continue_with";
  }

  return "signin_with";
};

const GoogleLoginInner = ({ buttonText, className, onSuccess, onFailure }) => {
  const handleSuccess = (credentialResponse) => {
    try {
      const credential = credentialResponse?.credential;

      if (!credential) {
        throw new Error("Missing Google credential response");
      }

      const payload = decodeJwtPayload(credential);

      onSuccess?.({
        accessToken: credential,
        tokenId: credential,
        googleId: payload.sub,
        credentialResponse,
        profileObj: {
          email: payload.email,
          imageUrl: payload.picture,
          name: payload.name,
        },
      });
    } catch (error) {
      onFailure?.({
        error: error.message || "Google login failed",
      });
    }
  };

  return (
    <div className={className}>
      <OAuthGoogleLogin
        onSuccess={handleSuccess}
        onError={() => onFailure?.({ error: "Google login failed" })}
        text={getGoogleButtonText(buttonText)}
      />
    </div>
  );
};

const GoogleLoginButton = ({
  buttonText,
  className,
  clientId,
  onSuccess,
  onFailure,
}) => {
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLoginInner
        buttonText={buttonText}
        className={className}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginButton;
